import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FloatingFocusManager, FloatingOverlay, useClick, useDismiss, useFloating, useInteractions, useRole, useTransitionStyles, } from "@floating-ui/react";
import clsx from "clsx";
import { useEffect, useId, useState } from "react";
import { Box } from "./Box";
import { useTheme } from "./ThemeProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const drawerClasses = {
    root: "MinervaDrawer-root",
    backdrop: "MinervaDrawer-backdrop",
    "placement-top": "MinervaDrawer-placementTop",
    "placement-bottom": "MinervaDrawer-placementBottom",
    "placement-left": "MinervaDrawer-placementLeft",
    "placement-right": "MinervaDrawer-placementRight",
};
export const Drawer = (props) => {
    const { variant = "temporary", strategy = "fixed", open: _open, onOpenChange, placement = "right", size = 80, duration = 150, sx, className, ...rest } = useDefaultProps({ component: "Drawer", props });
    const theme = useTheme();
    const [open, setOpen] = useState(_open);
    const { refs, context } = useFloating({
        open,
        onOpenChange: (open) => {
            setOpen(open);
            onOpenChange?.(open);
        },
    });
    const click = useClick(context);
    const dismiss = useDismiss(context, {
        outsidePressEvent: "mousedown",
        enabled: variant === "temporary",
    });
    const role = useRole(context);
    const { isMounted, styles: transitionStyles } = useTransitionStyles(context, {
        duration,
        initial: {
            height: placement === "top" || placement === "bottom" ? 0 : undefined,
            width: placement === "left" || placement === "right" ? 0 : undefined,
        },
        open: {
            width: placement === "left" || placement === "right" ? size : "100%",
            height: placement === "top" || placement === "bottom" ? size : "100%",
        },
    });
    const { getFloatingProps } = useInteractions([click, dismiss, role]);
    const labelId = useId();
    const descriptionId = useId();
    useEffect(() => {
        setOpen(_open);
    }, [_open]);
    const internalDrawer = (_jsx(FloatingFocusManager, { context: context, initialFocus: -1, children: _jsx(Box, { ref: refs.setFloating, "aria-labelledby": labelId, "aria-describedby": descriptionId, ...getFloatingProps(), ...rest, className: clsx([
                drawerClasses.root,
                placement === "top" && drawerClasses["placement-top"],
                placement === "bottom" && drawerClasses["placement-bottom"],
                placement === "left" && drawerClasses["placement-left"],
                placement === "right" && drawerClasses["placement-right"],
                className,
            ]), sx: mergeSx({
                position: strategy,
                overflow: "hidden",
                maxHeight: "100%",
                maxWidth: "100%",
                ...transitionStyles,
                [`&.${drawerClasses["placement-top"]}`]: {
                    top: 0,
                    left: 0,
                    right: 0,
                },
                [`&.${drawerClasses["placement-bottom"]}`]: {
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                [`&.${drawerClasses["placement-left"]}`]: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                },
                [`&.${drawerClasses["placement-right"]}`]: {
                    top: 0,
                    bottom: 0,
                    right: 0,
                },
            }, sx) }) }));
    return (isMounted &&
        (variant === "permanent" ? (internalDrawer) : (_jsx(FloatingOverlay, { lockScroll: variant === "temporary", className: drawerClasses.backdrop, style: {
                background: "rgba(0, 0, 0, 0.25)",
                zIndex: theme.zIndex.drawer,
                display: "flex",
            }, children: internalDrawer }))));
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map